import { createContext } from 'react';

export type SaveShortcutPriority = 'modal' | 'page';
export type SaveShortcutStrategy = 'active' | 'all';

export type SaveShortcutBoundaryRegistration = {
  active: boolean;
  id: symbol;
  priority: SaveShortcutPriority;
  strategy: SaveShortcutStrategy;
};

export type SaveShortcutScopeRegistration = {
  boundaryId: symbol | null;
  disabled: () => boolean;
  globalShortcut: boolean;
  id: symbol;
  onSave: () => unknown;
};

export type SaveShortcutBoundaryContextValue = {
  id: symbol;
  priority: SaveShortcutPriority;
};

export type SaveShortcutRegistry = {
  activateScope: (id: symbol) => void;
  registerBoundary: (boundary: SaveShortcutBoundaryRegistration) => () => void;
  registerScope: (scope: SaveShortcutScopeRegistration) => () => void;
};

export const SaveShortcutRegistryContext =
  createContext<SaveShortcutRegistry | null>(null);

export const SaveShortcutBoundaryContext =
  createContext<SaveShortcutBoundaryContextValue | null>(null);
